"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyData = void 0;
const react_1 = require("react");
const components_1 = require("@veeam/components");
const utils_1 = require("../utils");
const useCopyData = ({ data, dataMapper, onCopy }) => {
    const [isCopyingDoneShown, setCopyingDoneShown] = react_1.useState(false);
    const handleCopy = components_1.useDebounceCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const text = dataMapper(data);
        yield utils_1.copyToClipboard(text);
        setCopyingDoneShown(true);
        onCopy === null || onCopy === void 0 ? void 0 : onCopy();
    }), 200);
    react_1.useEffect(() => {
        if (!isCopyingDoneShown) {
            return;
        }
        const timerId = window.setTimeout(() => {
            setCopyingDoneShown(false);
        }, 2000);
        return () => {
            window.clearInterval(timerId);
        };
    }, [isCopyingDoneShown]);
    return {
        handleCopy,
        isCopyingDoneShown,
    };
};
exports.useCopyData = useCopyData;
//# sourceMappingURL=useCopyData.js.map